/*
 * @Author: cuikj kaijun.cui@biz-united.com.cn
 * @Date: 2024-05-20 14:34:38
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-12-30 15:02:38
 * @Description:
 */
import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';

import redPoolAccountName from '../components/redPoolAccountName.vue';
import basicChargeRate from '../components/basicChargeRate.vue';
import upAmountSettingVoList from '../components/upAmountSettingVoList.vue';

formCreate.component('redPoolAccountName', redPoolAccountName);
formCreate.component('basicChargeRate', basicChargeRate);
formCreate.component('upAmountSettingVoList', upAmountSettingVoList);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'main_form_new',
    };
  },
  mounted() {},
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'redPoolAccountName') {
        v.value = {
          redPoolAccountName: '',
          redPoolAccountCode: '',
        };
        v.on = {
          ...v.on,
          change: (val) => {
            this.setValue({ redPoolAccountCode: val.redPoolAccountCode });
          },
        };
      }
      if (v.field === 'remark') {
        v.props = {
          ...v.props,
          autosize: { minRows: 3, maxRows: 5 },
        };
      }
      if (v.field === 'basicChargeRate') {
        v.col.labelWidth = '150px';
      }

      if (v.field === 'startTime') {
        v.props = {
          ...v.props,
          type: 'daterange',
          rangeSeparator: '至',
          startPlaceholder: '开始日期',
          endPlaceholder: '结束日期',
        };
      }
      if (v.field === 'contractSettingVos') {
        v.props = {
          ...v.props,
          accept: '.doc,.docx',
          fileMsg: '只能上传doc/docx文件',
        };
        // rowData.props.fileMsg = '只能上传pdf/word/excel/ppt/png/jpg文件';
        // rowData.props.accept = '.pdf,.docx,.doc,.xlsx,.xls,.ppt,.pptx,.png,.jpg';
      }

      return v;
    },

    formComplete() {
      const { code } = this.formConfig;
      if (code !== 'add') {
        this.getDetail();
      }
    },
    // 查询详情
    getDetail() {
      const { row } = this.formConfig;
      request.get('/tax/v1/cash/setting/taxRateRuleSetting/findById', { id: row.id }).then((res) => {
        const { success, result } = res;
        if (success) {
          let time = [];
          if (result.startTime && result.endTime) {
            time = [result.startTime.slice(0, 10), result.endTime.slice(0, 10)];
          }
          this.setValue({
            ...result,
            startTime: time,
            redPoolAccountName: {
              redPoolAccountName: result.redPoolAccountName,
              redPoolAccountCode: result.redPoolAccountCode,
            },
            contractSettingVos: result.contractSettingVos.map((item, index) => ({
              ...item,
              fileName: item.attachName,
              url: item.attachUrl,
            })),
          });
        }
      });
    },
    submit() {
      const formData = this.getFormData();
      if (formData) {
        let tips = null;
        let tips2 = null; // 校验最大值大于最小值
        formData.upAmountSettingVoList.forEach((item, index) => {
          const next = formData.upAmountSettingVoList[index + 1];
          if (next) {
            if (item.maxAmount !== next.minAmount) {
              tips = '设定的税率阶梯需满足连续性，即下一阶梯的区间最小值必须等于上一节点的区间最大值。';
            }
          }
          if (item.maxAmount <= item.minAmount) {
            tips2 = `阶梯${index + 1}的最大值必须大于最小值`;
          }
        });
        if (tips) {
          this.$message.error(tips);
          return;
        }
        if (tips2) {
          this.$message.error(tips2);
          return;
        }
        const { code } = this.formConfig;
        const url = '/tax/v1/cash/setting/taxRateRuleSetting/save';
        const time = formData.startTime;
        const data = {
          ...formData,
          startTime: `${time[0]} 00:00:00`,
          endTime: `${time[1]} 23:59:59`,
          ...formData.redPoolAccountName,
          contractSettingVos: formData.contractSettingVos.map((item, index) => ({
            ...item,
            attachName: item.fileName,
            attachUrl: item.url,
            indexNum: index + 1,
          })),
        };
        console.log(data);
        // if (code === 'edit') {
        //   data = {
        //     ...data,
        //     id: this.formConfig.row.id,
        //   };
        //   url = '/tax/v1/taxGovRateConfig/editRedPoolAccount';
        // }
        request.post(url, data).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
